import { useCountUp } from '../../hooks/useCountUp';

/** Chiffre clé qui compte de 0 jusqu'à sa valeur quand il entre dans le viewport. */
export function StatCounter({ valeur, label }) {
  const { ref, display } = useCountUp(valeur);
  return (
    <div className="chiffre" ref={ref}>
      <span className="chiffre__valeur">{display}</span>
      <span className="chiffre__label">{label}</span>
    </div>
  );
}
